import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { bootstrapEhrInviteHash } from "./utils/ehrInviteHashBootstrap";
import { installModalScrollFix } from "./utils/modalScrollFix";
import { installWrapRightAlign } from "./utils/wrapRightAlign";
import { HASH_BOOTSTRAP_TIMEOUT_MS, withTimeout } from "./utils/asyncUtils";
import { registerAxiosSessionGuard } from "./utils/sessionExpiry";

// Must run before any import of App (and thus supabaseClient), or GoTrue will consume the
// invite tokens on the EHR origin and the same hash fails on the patient portal with session_not_found.
const redirected = bootstrapEhrInviteHash();

const rootEl = document.getElementById("root") as HTMLElement;

if (!redirected) {
  // Keep in the main bundle so a stale async chunk
  // (ERR_CONTENT_DECODING_FAILED) cannot blank the boot sequence.
  registerAxiosSessionGuard();

  void (async () => {
    try {
      const { supabase } = await import("./supabaseClient");
      const { ensureSessionFromUrlHash } = await import(
        "./utils/ehrSessionFromUrlHash"
      );

      try {
        await withTimeout(
          ensureSessionFromUrlHash(supabase),
          HASH_BOOTSTRAP_TIMEOUT_MS,
          "Invite session bootstrap timed out",
        );
      } catch (error) {
        console.warn("[boot] ensureSessionFromUrlHash:", error);
      }

      // Must beat react-remove-scroll to `document`, which it only listens on
      // once the first modal opens.
      installModalScrollFix();
      installWrapRightAlign();

      const { default: App } = await import("./App");
      const root = ReactDOM.createRoot(rootEl);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
      );
    } catch (error) {
      console.error("[boot] Fatal app bootstrap failure:", error);
      rootEl.innerHTML =
        '<div style="font-family:sans-serif;padding:2rem;max-width:36rem">' +
        "<h1>Failed to load the app</h1>" +
        "<p>A stale or corrupted script chunk failed to load. Hard-refresh " +
        "(Ctrl+Shift+R), or restart the frontend dev server after clearing " +
        "<code>node_modules/.cache</code>.</p>" +
        "</div>";
    }
  })();
}
